import { create } from "zustand";
import { ConsentChoice } from "@/app/types/consent/ConsentChoice";
import { UCookie } from "@/app/utils/UCookie";
import {
  CONSENT_COOKIE_MAX_AGE,
  CookieKey,
  GOOGLE_ANALYTICS_COOKIE_PREFIX,
} from "@/app/vars/Storage";

export type ConsentState = {
  choice?: ConsentChoice;
  initialized: boolean;
  isBannerOpen: boolean;
  isSettingsOpen: boolean;
  onInit(): void;
  accept(): void;
  refuse(): void;
  save(analytics: boolean): void;
  setSettingsOpen(isSettingsOpen: boolean): void;
};

function readChoice(): ConsentChoice | undefined {
  const raw = UCookie.read(CookieKey.ANALYTICS_CONSENT);
  return Object.values(ConsentChoice).find((choice) => choice === raw);
}

export const ConsentStore = create<ConsentState>()((set, getState) => ({
  choice: undefined,
  initialized: false,
  isBannerOpen: false,
  isSettingsOpen: false,

  onInit: () => {
    const choice = readChoice();
    set({ choice, initialized: true, isBannerOpen: choice === undefined });
  },

  accept: () => {
    getState().save(true);
  },

  refuse: () => {
    getState().save(false);
  },

  save: (analytics: boolean) => {
    const choice = analytics ? ConsentChoice.ACCEPTED : ConsentChoice.REFUSED;
    UCookie.write(CookieKey.ANALYTICS_CONSENT, choice, CONSENT_COOKIE_MAX_AGE);
    if (!analytics) {
      UCookie.removeByPrefix(GOOGLE_ANALYTICS_COOKIE_PREFIX);
    }
    set({ choice, isBannerOpen: false });
  },

  setSettingsOpen: (isSettingsOpen: boolean) => {
    set({ isSettingsOpen });
  },
}));
